// Vendors
import $ from 'jquery';

// Toggle mobile nav
$('[data-toggle="nav-mobile"]').on('click', (event) => {
  event.preventDefault();
  $(event.currentTarget).toggleClass('hamburger--active');
  $('.mobile-nav').toggleClass('mobile-nav--visible');
  $('.mobile-nav').scrollTop(0);
  $('body').toggleClass('nav-mobile-is-visible');
  $('html').toggleClass('nav-mobile-is-visible');
});

// Toggle nested menu items
$('.mobile-nav .caret').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  if (!$this.siblings('.sub-menu').hasClass('sub-menu--visible')) {
    $this.siblings('.sub-menu').addClass('sub-menu--visible');
    $this.removeClass('fa-angle-down');
    $this.addClass('fa-angle-up');
  } else {
    $this.siblings('.sub-menu').removeClass('sub-menu--visible');
    $this.removeClass('fa-angle-up');
    $this.addClass('fa-angle-down');
  }
});

// Toggle nested menu items
$('.mobile-nav__footer .page_item a').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  if (!$this.siblings('.sub-menu').hasClass('sub-menu--visible')) {
    $this.siblings('.sub-menu').addClass('sub-menu--visible');
    $this.siblings('.caret').removeClass('fa-angle-down');
    $this.siblings('.caret').addClass('fa-angle-up');
  } else {
    $this.siblings('.sub-menu').removeClass('sub-menu--visible');
    $this.siblings('.caret').removeClass('fa-angle-up');
    $this.siblings('.caret').addClass('fa-angle-down');
  }
});
